import React, { Children } from 'react';
import { DollarSignIcon, GlobeIcon, HeartIcon, ClipboardListIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const sessions = [{
  id: 'financial',
  title: 'Financial Stewardship',
  scripture: 'The plans of the diligent lead to profit.',
  reference: 'Proverbs 21:5',
  description: "Discover God's principles for money management that create true generational wealth.",
  icon: DollarSignIcon,
  color: 'from-emerald-500 to-emerald-700'
}, {
  id: 'missionary',
  title: 'Missionary Work',
  scripture: 'For I know the plans I have for you.',
  reference: 'Jeremiah 29:11',
  description: 'Learn how to discover where God is calling you to serve and create impact that changes lives.',
  icon: GlobeIcon,
  color: 'from-blue-500 to-blue-700'
}, {
  id: 'marriage',
  title: 'Marriage Ministry',
  scripture: 'Husbands, love your wives as Christ loved the church.',
  reference: 'Ephesians 5:25',
  description: 'Discover godly leadership and biblical love that transforms your household.',
  icon: HeartIcon,
  color: 'from-rose-500 to-rose-700'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};
export function SessionsPage() {
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-168">
      <div className="bg-gradient-to-br from-[#374151] to-black pt-12 pb-8 px-6 rounded-b-[2rem] shadow-lg relative overflow-hidden" data-id="element-169">
        <div className="absolute -right-10 -top-10 w-40 h-40 bg-[#7B2D8E] opacity-20 rounded-full blur-3xl" data-id="element-170" />
        <h1 className="text-3xl font-black text-white mb-2 relative z-10" data-id="element-171">
          Breakout Sessions
        </h1>
        <p className="text-gray-300 font-medium text-lg relative z-10" data-id="element-172">
          Choose your path to grow sharper and lead with confidence.
        </p>
      </div>

      <div className="px-6 py-8" data-id="element-173">
        <motion.div variants={containerVariants} initial="hidden" animate="show" className="space-y-8" data-id="element-174">
          {sessions.map((session, index) => {
          const Icon = session.icon;
          const number = (index + 1).toString().padStart(2, '0');
          return <motion.div key={session.id} variants={cardVariants} className="bg-white rounded-[2rem] shadow-xl shadow-gray-200/50 border border-gray-100 overflow-hidden relative group" data-id="element-175">
                <div className="absolute top-0 right-0 bg-[#7B2D8E] text-white font-black text-sm px-4 py-2 rounded-bl-2xl z-10 shadow-md" data-id="element-176">
                  {number}
                </div>

                <div className={`p-6 bg-gradient-to-r ${session.color} relative overflow-hidden`} data-id="element-177">
                  <div className="absolute inset-0 bg-black/10" data-id="element-178" />
                  <div className="absolute -right-4 -bottom-4 opacity-20 transform rotate-12 group-hover:rotate-0 group-hover:scale-110 transition-transform duration-500" data-id="element-179">
                    <Icon className="w-32 h-32 text-white" data-id="element-180" />
                  </div>

                  <div className="relative z-10 flex items-center" data-id="element-181">
                    <div className="p-3 bg-white/20 backdrop-blur-md rounded-2xl mr-4 border border-white/30" data-id="element-182">
                      <Icon className="w-8 h-8 text-white" data-id="element-183" />
                    </div>
                    <h2 className="text-2xl font-black text-white pr-8 leading-tight" data-id="element-184">
                      {session.title}
                    </h2>
                  </div>
                </div>

                <div className="p-6" data-id="element-185">
                  <div className="relative mb-6 pl-6" data-id="element-186">
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#D4A017] to-transparent rounded-full" data-id="element-187" />
                    <span className="absolute -left-2 -top-4 text-6xl font-serif text-[#D4A017] opacity-20 leading-none" data-id="element-188">
                      &ldquo;
                    </span>
                    <p className="text-lg font-serif italic text-gray-800 leading-relaxed font-medium" data-id="element-189">
                      {session.scripture}
                    </p>
                    <p className="text-sm font-bold text-[#D4A017] mt-2 tracking-wide uppercase" data-id="element-190">
                      — {session.reference}
                    </p>
                  </div>

                  <p className="text-gray-600 leading-relaxed text-lg" data-id="element-191">
                    {session.description}
                  </p>
                </div>
              </motion.div>;
        })}

          <motion.div variants={cardVariants} className="pt-2" data-id="element-192">
            <a href="https://www.akiosurvey.com/svy/ae1fujf" target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center py-5 px-6 bg-gradient-to-r from-[#D4A017] to-[#F3C642] text-[#7B2D8E] rounded-2xl font-black text-lg shadow-xl shadow-amber-500/20 hover:shadow-amber-500/40 transition-all active:scale-[0.98]" data-id="element-193">
              <ClipboardListIcon className="w-6 h-6 mr-3" data-id="element-194" />
              Take the Conference Survey
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>;
}